export const LAY_DANH_SACH_VAI_TRO_SAGA = 'LAY_DANH_SACH_VAI_TRO_SAGA'
export const THAY_DOI_VAI_TRO_SAGA = 'THAY_DOI_VAI_TRO_SAGA'